let Calendar;

export default store => ({
  path: "calendar",
  getComponent(nextState, cb) {
    Promise.all([
      import("../../store/reducers"),
      import("./containers/CalendarContainer"),
      import("../../containers/PaymentStateContainer"),
      import("@tenderplan3/store/modules/calendar"),
      import("@tenderplan3/store/modules/comments")
    ]).then(([reducers, component, wrapPayment, calendar, comments]) => {
      const { injectReducer } = reducers;

      Calendar = Calendar || wrapPayment.default(component.default);

      injectReducer(store, { key: "calendar", reducer: calendar.default });
      injectReducer(store, { key: "comments", reducer: comments.default });

      cb(null, Calendar);
    });
  },
  onEnter(nextState, replace, callback) {
    const state = store.getState();
    if (!state.globals.paid && !state.globals.admin) {
      replace("/app/settings?section=company");
    }
    callback();
  }
});
